import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "global/context/authContextDefinition";
import { useAuth } from 'global/context/AuthProviderV2';

export const PrivateRoute = () => {
    //const authContext = useContext(AuthContext);
    const location = useLocation();
    const { isAuthenticated } = useAuth();

    
    //const { user } = authContext;
    //console.log("location:"+JSON.stringify(location));
    return isAuthenticated ? <Outlet /> : location.pathname==='/encuesta'? <Navigate to="/login" state={{ from: location }} replace />:<Navigate to="/modelo" replace />;
};